import { useMemo } from "react";

type ForloebDuration = {
  months: number;
  days: number;
}

export const getForloebDuration = (startDate: Date, endDate: Date): ForloebDuration => {
    const selectedEndDayWithAddedDay = endDate.addDays(1); //We want to include both selectedStartDate and selectedEndDate in duration
    const durationMonths = startDate.getMonthDiff(selectedEndDayWithAddedDay);
    const startDateWithAddedMonths = startDate.addMonths(durationMonths);
    if(startDateWithAddedMonths.getDate() === selectedEndDayWithAddedDay.getDate()){
        return { months: durationMonths, days: 0 } //Early exit if selectedStartDate is the first day of the month, and selectedEndDate is the last day of the month
    }

    const durationDays = startDateWithAddedMonths.getDayDiff(selectedEndDayWithAddedDay);
    return { months: durationMonths, days: durationDays } as ForloebDuration;
}

const useForloebDuration = (startDate?: Date, endDate?: Date) => {

  const forloebDuration = useMemo(() => {
    if (startDate === undefined || endDate === undefined) { return undefined };

    return getForloebDuration(startDate, endDate);
  }, [startDate, endDate]);

  return {
    forloebDuration
  }
}

export default useForloebDuration;
